import React from 'react';
import '../App.css';
import { FaTeethOpen, FaSmile, FaProcedures, FaAddressCard } from 'react-icons/fa';

const Services = () => {
  return (
    <section id="services" className="services-section">
      <h2>Tailored treatments just for you</h2>
      <div className="service-cards">
        <div className="service-card">
          <FaTeethOpen size={50} className="service-icon" />
          <h3>General Dentistry</h3>
        </div>
        <div className="service-card">
          <FaSmile size={50} className="service-icon" />
          <h3>Ultrasonic cleaning</h3>
        </div>
        <div className="service-card">
          <FaTeethOpen size={50} className="service-icon" />
          <h3>Painless root canal therapy</h3>
        </div>
        <div className="service-card">
          <FaSmile size={50} className="service-icon" />
          <h3>Smile Designing</h3>
        </div>
        <div className="service-card">
          <FaTeethOpen size={50} className="service-icon" />
          <h3>Peditric Dentistry</h3>
        </div>
        <div className="service-card">
          <FaSmile size={50} className="service-icon" />
          <h3>Braces/Aligners</h3>
        </div>
        <div className="service-card">
          <FaTeethOpen size={50} className="service-icon" />
          <h3>Tooth Whitening</h3>
        </div>  
        <div className="service-card">
          <FaTeethOpen size={50} className="service-icon" />
          <h3>Digital Dental X-Ray </h3>
        </div>

        <div className="service-card">
          <FaProcedures size={50} className="service-icon" />
          <h3>Extraction & Gum Surgery</h3>
        </div>
        
        <div className="service-card more-services">
  <FaAddressCard size={50} className="many" />
<h3>✨ Discover more personalized treatments during your visit.</h3>
</div>
      </div>
      <button className="service-btn">“Experience the Care You Deserve”</button>

    </section>
    
  );
};

export default Services;
